<template>
  <div style="width: 320px; height: 240px; background: salmon">
    <video-track :track="participant.tracks.screenVideo.track"/>
  </div>
</template>

<script>
import VideoTrack from "./VideoTrack";
export default {
  name: "ParticipantScreenShare",
  components: {VideoTrack},
  props: ["participant"]
}
</script>

<style scoped>

</style>